import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Button, TextField, Grid, FormLabel } from '@mui/material';
import GlobalDialogContent from '../GlobalDialogContent';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../redux/reducer/snackbarSlice';
import { CommitmentStatusUpdate } from '../../../utils/services/project/project';
import { closeDialog } from '../../../redux/reducer/dialogSlice';
import { RootState } from '../../../redux/store';
import { setModuleRefresh } from '../../../redux/reducer/registration/RefreshSlice';
import "react-quill/dist/quill.snow.css";
import "draft-js/dist/Draft.css";
import PageLang from '../../../config/page.languge';


const RejectCommit = () => {
    const dispatch = useDispatch();
    const projectData = useSelector((state: RootState) => state.dialog.payload);
    const lang=useSelector((state:RootState)=>state.lang.language)

    const formik = useFormik({
        initialValues: {
            unitsCommitted: projectData?.no_of_unit,
            costPerUnit: projectData?.cost,
            totalCommitment: projectData?.total_implementation,
            comment: ''
        },
        validationSchema: Yup.object({
            unitsCommitted: Yup.number().min(1, PageLang?.dialogues.rejectCommitDialogue[1][lang]).required(PageLang?.dialogues.rejectCommitDialogue[0][lang]),
            costPerUnit: Yup.number().min(0, PageLang?.dialogues.rejectCommitDialogue[2][lang]).required(PageLang?.dialogues.rejectCommitDialogue[0][lang]),
            totalCommitment: Yup.string(),
            comment: Yup.string().required(PageLang?.dialogues.rejectCommitDialogue[3][lang])
            
        }),
        onSubmit: async (values, { setSubmitting }) => {
            if (projectData?.id) {
                const reqPayload = {
                    request_id: projectData?.id,
                    user_id: projectData?.user_id,
                    status: "rejected",
                    no_of_unit: values.unitsCommitted,
                    cost: values.costPerUnit,
                    total_implementation: values.totalCommitment,
                    comment: values.comment
                };

                const { code } = await CommitmentStatusUpdate(reqPayload);

                if (code === 200) {
                    dispatch(setModuleRefresh({ moduleName: 'rejectCommitment', refresh: true }));
                    dispatch(closeDialog());
                    dispatch(showSnackbar({ type: "success", message: PageLang?.dialogues.rejectCommitDialogue[4][lang] }));
                } else {
                    dispatch(showSnackbar({ type: "error", message: PageLang?.dialogues.rejectCommitDialogue[5][lang]}));
                }
            }
        }
    });
    
    return (

        <>
            <form onSubmit={formik.handleSubmit}>
                <GlobalDialogContent
                    dialogBody={
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    label={PageLang?.dialogues.rejectCommitDialogue[6][lang]}
                                    name="unitsCommitted"
                                    type="text"
                                    size='small'
                                    value={formik.values.unitsCommitted}
                                    InputProps={{
                                        disabled: true,
                                    }}
                                    onChange={(e) => {
                                        let value = e.target.value.replace(/[^0-9]/g, "");
                                        formik.setFieldValue(e.target.name, value);
                                    }}
                                    error={formik.touched.unitsCommitted && Boolean(formik.errors.unitsCommitted)}
                                    helperText={formik.touched.unitsCommitted && Boolean(formik.errors.unitsCommitted)}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    label={PageLang?.dialogues.rejectCommitDialogue[7][lang]}
                                    name="costPerUnit"
                                    type="text"
                                    size='small'
                                    value={formik.values.costPerUnit}
                                    InputProps={{
                                        disabled: true,
                                    }}
                                    onChange={(e) => {
                                        let value = e.target.value.replace(/[^0-9]/g, "");
                                        formik.setFieldValue(e.target.name, value);
                                        formik.setFieldValue('totalCommitment', Number(value) * Number(formik.values.unitsCommitted));
                                    }}
                                    error={formik.touched.costPerUnit && Boolean(formik.errors.costPerUnit)}
                                    helperText={formik.touched.costPerUnit && Boolean(formik.errors.costPerUnit)}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    label={PageLang?.dialogues.rejectCommitDialogue[8][lang]}
                                    name="totalCommitment"
                                    type="text"
                                    InputProps={{
                                        disabled: true,
                                    }}
                                    autoFocus
                                    size='small'
                                    value={formik.values.totalCommitment}

                                />
                            </Grid>

                            <Grid item xs={12}  sm={12} md={12} sx={{mt: 1}}>
                                <FormLabel>{PageLang?.projectCreationFormData.status[3][lang]} <span style={{color: 'red'}}>*</span> </FormLabel>
                                <TextField
                                        name="comment"
                                        value={formik.values.comment}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.comment && Boolean(formik.errors.comment)}
                                        helperText={formik.touched.comment && formik.errors.comment}
                                        placeholder={PageLang?.dialogues.rejectCommitDialogue[9][lang]}
                                        multiline
                                        rows={3}
                                        size="small"
                                        fullWidth
                                    />
                            </Grid>
                        </Grid>
                    }
                    dialogFooter={
                        <>
                            <Button type="submit" variant="contained" color="primary">
                                {PageLang?.projectCreationFormData.status[1][lang]}
                            </Button>
                        </>
                    }
                />
            </form>

        </>
    );
};

export default RejectCommit;


